import { useState, useRef } from 'react';

function Navbar() {
  const [showServicesDropdown, setShowServicesDropdown] = useState(false);
  const dropdownRef = useRef(null);

  // 添加滚动函数
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      // 滚动到元素位置，并考虑导航栏高度的偏移
      const navbarHeight = 96; // 约6rem
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - navbarHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <nav style={{
      position: 'fixed',
      width: '100vw',
      top: 0,
      left: 0,
      zIndex: 50,
      backgroundColor: '#000000',
      backdropFilter: 'blur(8px)'
    }}>
      <div style={{
        width: '100%',
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0.5rem 2rem'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          {/* Logo */}
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img src="/logo.png" alt="DOOB" style={{ height: '6rem' }} />
          </div>

          {/* Navigation Links */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '2.5rem',
            fontSize: '1rem',
            fontWeight: '500'
          }}>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('banner');
              }}
              style={{
                color: 'white',
                textDecoration: 'none',
                transition: 'color 0.3s ease'
              }}
              onMouseEnter={(e) => e.target.style.color = '#0F7E8D'}
              onMouseLeave={(e) => e.target.style.color = 'white'}
            >
              Home
            </a>

            {/* Services with dropdown */}
            <div
              ref={dropdownRef}
              style={{ position: 'relative' }}
              onMouseEnter={() => setShowServicesDropdown(true)}
              onMouseLeave={() => setShowServicesDropdown(false)}
            >
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('services');
                }}
                style={{
                  color: 'white',
                  textDecoration: 'none',
                  display: 'block',
                  padding: '0.5rem 0',
                  transition: 'color 0.3s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = '#0F7E8D'}
                onMouseLeave={(e) => e.target.style.color = 'white'}
              >
                Our Service
              </a>
            </div>

            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('working-process');
              }}
              style={{
                color: 'white',
                textDecoration: 'none',
                transition: 'color 0.3s ease'
              }}
              onMouseEnter={(e) => e.target.style.color = '#0F7E8D'}
              onMouseLeave={(e) => e.target.style.color = 'white'}
            >
              Smart Investment
            </a>
            {/* <a href="#" style={{
              color: 'white',
              textDecoration: 'none'
            }}>Clients</a>
            <a href="#" style={{
              color: 'white',
              textDecoration: 'none'
            }}>Meet The Team</a> */}
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('contact-form');
              }}
              style={{
                color: 'white',
                textDecoration: 'none',
                transition: 'color 0.3s ease'
              }}
              onMouseEnter={(e) => e.target.style.color = '#0F7E8D'}
              onMouseLeave={(e) => e.target.style.color = 'white'}
            >
              Contact Us
            </a>
          </div>

          {/* Button */}
          {/* <div style={{ display: 'flex', alignItems: 'center' }}>
            <button style={{
              backgroundColor: '#0F7E8D',
              color: 'white',
              padding: '0.5rem 1.5rem',
              borderRadius: '9999px',
              border: 'none',
              cursor: 'pointer',
              fontSize: '0.9rem',
              fontWeight: '500'
            }}
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('contact-form');
              }}>
              BUY NOW
            </button>
          </div> */}
        </div>
      </div>
    </nav>
  );
}

export default Navbar; 